import { createContext, useContext } from 'react'

import { LookupList } from '@domain'

export type LookupContextValue = LookupList
export const LookupsContext = createContext<LookupContextValue | undefined>(undefined)

/**
 * Return a value for the given key
 *
 * @example
 * const languages = useLookup(Lookup.currency)
 */
export const useLookup = (key: string): SimpleListItem[] => {
	const context = useContext(LookupsContext)
	if (context === undefined) {
		throw new Error('useLookup must be used within a LookupsProvider')
	}
	return context[key]
}
